import { parse, isValid } from 'date-fns';

export const transformInSnakeCase = (str: string) =>
  str.replace(/ /g, '_').toLowerCase();

export const transformKebabCaseInSnakeCase = (str: string) => {
  return transformInSnakeCase(str).replace(/-/g, '_');
};

export const transformCamelCaseToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

/**
 * Parses various date input formats and returns a Date object
 * Supported formats: DDMMYYYY, DD/MM/YYYY
 */
export const formatDateInput = (input: string): Date | null => {
  if (!input) return null;

  const trimmed = input.trim();

  // Try parsing different formats
  const formats = [
    { pattern: /^\d{8}$/, format: 'ddMMyyyy' }, // DDMMYYYY
    { pattern: /^\d{2}\/\d{2}\/\d{4}$/, format: 'dd/MM/yyyy' }, // DD/MM/YYYY
  ];

  for (const { pattern, format } of formats) {
    if (pattern.test(trimmed)) {
      const date = parse(trimmed, format, new Date());
      if (isValid(date)) {
        return date;
      }
      return null;
    }
  }

  return null;
};
